export const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 520,
  maxWidth: "calc(100vw - 32px)",
  maxHeight: "90vh",
  background: "#fff",
  borderRadius: "12px",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const headerStyle = {
  background: "#126ABC",
  padding: "16px 20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const headerTitleStyle = {
  color: "#fff",
  fontWeight: 600,
  fontSize: "16px",
};

export const headerCloseButtonStyle = {
  color: "#fff",
  p: 0,
};

export const bodyStyle = {
  p: "24px",
  flex: 1,
  overflowY: "auto",
};

export const subtitleStyle = {
  fontSize: "13px",
  color: "#888",
  mb: 2,
};

export const uploadBoxStyle = {
  border: "1.5px dashed #D0D5DD",
  borderRadius: "8px",
  p: "20px",
  textAlign: "center",
  cursor: "pointer",
  mb: 2,
  background: "#FAFAFA",
  transition: "border-color 0.2s, background 0.2s",
  "&:hover": {
    borderColor: "#126ABC",
    background: "#F0F6FF",
  },
};

export const uploadBoxActiveStyle = {
  ...uploadBoxStyle,
  borderColor: "#126ABC",
  background: "#F0F6FF",
};

export const uploadIconWrapStyle = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  background: "#E8F1FB",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 8px",
};

export const uploadFileNameStyle = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#126ABC",
  mt: 0.5,
};

export const uploadFileSizeStyle = {
  fontSize: "12px",
  color: "#888",
};

export const uploadPlaceholderStyle = {
  fontSize: "13px",
  color: "#555",
  mt: 0.5,
};

export const uploadHintStyle = {
  fontSize: "11px",
  color: "#aaa",
  mt: 0.5,
};

export const fieldLabelStyle = {
  fontWeight: 500,
  mb: 0.5,
  fontSize: "13px",
  color: "#333",
};

export const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "14px",
  },
};

export const errorTextStyle = {
  fontSize: "12px",
  color: "#D32F2F",
  mt: 1,
};

export const footerStyle = {
  p: "16px 24px",
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  borderTop: "1px solid #F0F0F0",
  background: "#fff",
};

export const cancelButtonSx = {
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  px: 3,
  height: "40px",
  borderColor: "#D0D5DD",
  color: "#555",
  "&:hover": { borderColor: "#126ABC", color: "#126ABC" },
};

export const confirmButtonSx = {
  background: "#126ABC",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  px: 4,
  height: "40px",
  "&:hover": { background: "#0f5a9e" },
  "&.Mui-disabled": { background: "#9BBEE4", color: "#fff" },
};
